<body class="ltr main-body leftmenu">
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="IAReport">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-9">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/purse.png" class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            IA Marks Report Download
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Generate IA Marks Report
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row clearfix mt-2">

                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="w-100"
                                                    style="font-size: 12px;">
                                                    <mat-label style="font-size: 12px;">Session</mat-label>
                                                    <mat-select #select232 placeholder="Session" class="colorblack"
                                                        formControlName="SessionId" style="font-size: 12px;">
                                                        <mat-select-filter *ngIf="select232.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                            [array]="sessionList"
                                                            (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of SessionFilterList"
                                                            [value]="item.SnNo" style="font-size: 12px;">
                                                            {{item.SnNo}} - {{item.SnName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="IAReport.get('SessionId').hasError('required')"
                                                        style="font-size: 11px;">
                                                        Session is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="w-100"
                                                    style="font-size: 12px;">
                                                    <mat-label style="font-size: 12px;">Course</mat-label>
                                                    <mat-select #courseSelect placeholder="Course" class="colorblack"
                                                        formControlName="course"
                                                        [disabled]="!IAReport.get('SessionId').value"
                                                        style="font-size: 12px;">
                                                        <mat-select-filter *ngIf="courseSelect.focused"
                                                            [placeholder]="'Search Course...'"
                                                            [displayMember]="'CoName'" [array]="CourseList"
                                                            (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCourseList"
                                                            [value]="item.CoCgCoCode" style="font-size: 12px;">
                                                            {{item.CoCgCoCode}} - {{item.CoName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="IAReport.get('course').hasError('required')"
                                                        style="font-size: 11px;">
                                                        Course is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="w-100"
                                                    style="font-size: 12px;">
                                                    <mat-label style="font-size: 12px;">College</mat-label>
                                                    <mat-select formControlName="college" multiple
                                                        [disabled]="!IAReport.get('course').value"
                                                        (selectionChange)="onCollegeSelect($event)"
                                                        style="font-size: 12px;">
                                                        <mat-select-filter *ngIf="true"
                                                            [placeholder]="'Search College...'"
                                                            [displayMember]="'CgName'" [array]="collegeList"
                                                            (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                                        <mat-option (click)="selectAllColleges()" [value]="'selectAll'"
                                                            [checked]="isAllSelected()" style="font-size: 12px;">
                                                            <strong>Select All</strong>
                                                        </mat-option>
                                                        <mat-option *ngFor="let item of filteredCollegeList"
                                                            [value]="item.CgCode"
                                                            [checked]="selectedColleges.includes(item.CgCode)"
                                                            style="font-size: 12px;">
                                                            {{ item.CgCode }} - {{ item.CgName }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="IAReport.get('college').hasError('required')"
                                                        style="font-size: 11px;">
                                                        College is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="w-100"
                                                    style="font-size: 12px;">
                                                    <mat-label style="font-size: 12px;">Exam</mat-label>
                                                    <mat-select formControlName="Exam" placeholder="Exam"
                                                        class="colorblack" [disabled]="!canSelectExam()"
                                                        (selectionChange)="onExamChange($event.value)"
                                                        style="font-size: 12px;">
                                                        <mat-select-filter *ngIf="true" [placeholder]="'Search Exam...'"
                                                            [displayMember]="'EmName'" [array]="ExamAList"
                                                            (filteredReturn)="filteredExamAList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredExamAList"
                                                            [value]="item.EmId" style="font-size: 12px;">
                                                            {{item.EmCode}} - {{item.EmName}}
                                                        </mat-option>
                                                        <mat-option *ngIf="canSelectExam() && ExamAList.length === 0"
                                                            disabled style="font-size: 12px;">
                                                            No exams available
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="IAReport.get('Exam').hasError('required')"
                                                        style="font-size: 11px;">
                                                        Exam is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- Branch Dropdown - Appears conditionally when exam has streams -->
                                        <div class="col-sm-2" *ngIf="showBranchField()">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="w-100"
                                                    style="font-size: 12px;">
                                                    <mat-label style="font-size: 12px;">Branch</mat-label>
                                                    <mat-select formControlName="Branch" placeholder="Branch"
                                                        class="colorblack" [disabled]="!IAReport.get('Exam').value"
                                                        style="font-size: 12px;">
                                                        <mat-select-filter *ngIf="true"
                                                            [placeholder]="'Search Branch...'"
                                                            [displayMember]="'StrName'" [array]="BranchList"
                                                            (filteredReturn)="filteredBranchList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredBranchList"
                                                            [value]="item.StrId" style="font-size: 12px;">
                                                            {{item.StrCode}} - {{item.StrName}}
                                                        </mat-option>
                                                        <mat-option *ngIf="BranchList.length === 0" disabled
                                                            style="font-size: 12px;">
                                                            No branches available
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row justify-content-center mt-4" *ngIf="showDownloadButton">
                                        <div class="col-6 text-center">
                                            <div class="card card-success">
                                                <div class="card-body">
                                                    <div class="btn-group" role="group">
                                                        <button type="button" class="btn btn-primary btn-lg px-4"
                                                            (click)="downloadIAReport()"
                                                            [disabled]="isDownloading || IAReport.invalid">
                                                            <span *ngIf="!isDownloading">
                                                                <i class="fas fa-download mr-2"></i>
                                                                Download PDF Report
                                                            </span>
                                                            <span *ngIf="isDownloading">
                                                                <i class="fas fa-spinner fa-spin mr-2"></i>
                                                                Downloading...
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-6 text-center" *ngIf="showExcel">
                                            <div class="card card-success">
                                                <div class="card-body">
                                                    <div class="btn-group" role="group">
                                                        <button type="button"
                                                            class="btn btn-primary btn-lg px-4 btn-icon-text"
                                                            (click)="downloadIAMarksReportExcel()"
                                                            [disabled]="isDownloading || IAReport.invalid">
                                                            <span style="display: flex; align-items: center;">
                                                                <img alt="Logo" width="20vh"
                                                                    src="../../assets/images/arrow (1).png"
                                                                    style="margin-right: 7px;">
                                                                Download Excel Report
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="row justify-content-center mt-3" *ngIf="canSelectExam() && ExamAList.length === 0 && selectedColleges.length > 0">
                                        <div class="col-12">
                                            <div class="alert alert-warning text-center">
                                                <i class="fas fa-exclamation-triangle mr-2"></i>
                                                No exams found for the selected course. Please check if exams are available for course "{{getCourseName(IAReport.get('course').value)}}".
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</body>